/*
   The function will convert text/title to Slug
  ? ex : 'Chinese 华文', will be converted 'chinese-c2'
*/
export function convertToSlug(name: string) {
  return name
    .toLowerCase()
    .replace('.', '')
    .replace('华文', 'c2')
    .replace("'", '')
    .replace(' (', '-')
    .replace(')', '')
    .replaceAll(' ', '-');
}
